module.exports = __webpack_public_path__ + "img/faxin.8af2df4d.svg";